import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Modal,
  Box,
  useMediaQuery,
} from "@mui/material";
import BusinessFormModal from "../../utils/BusinessFormModal";
import { toast } from "react-toastify";
import SequentialVideoModals from "../../utils/IntroVideoModal";
// const VISUALIZE__URL = import.meta.env.VITE_VISUALIZE__URL;
// const LIGER_DOMAIN = import.meta.env.VITE_LIGER_HOST_NAME;
// const hostName = window.location.host
// const isLigerDomain = hostName.includes(LIGER_DOMAIN);

const AuthChecker: React.FC = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [openBusinessModal, setOpenBusinessModal] = useState(false)
  const [accessModal, setAccessModal] = useState(false)
  const [showIntroModal, setShowIntroModal] = useState(false)
  const isMobile = useMediaQuery("(max-width:600px)")
  console.log("isMobile", isMobile)
  useEffect(() => {
    const interval = setInterval(() => {
      const token = Cookies.get("userToken");
      const isFreeAccess = localStorage.getItem("viewAccess");
      const expiresOn = localStorage.getItem("expiresOn");

      const expiresAt = new Date(expiresOn ?? "");
      const now = new Date();

      const shouldOpenBusinessModal = ((expiresAt && expiresAt.getTime() <= now.getTime())) || isFreeAccess === "2";
      setOpenBusinessModal(shouldOpenBusinessModal);

      if (!token) {
        setOpen(true);
      }
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (openBusinessModal) {
      toast.error("Your free access has expired. Please add your business details to continue.");
    }
  }, [openBusinessModal]);

  useEffect(() => {
    const firstTimeUser = localStorage.getItem("firstTimeUser");

    if (firstTimeUser === "yes") {
      setShowIntroModal(true);
    } else {
      setShowIntroModal(false);
    }
  }, [])




  const handleLogin = () => {
    Cookies.remove("userToken");
    setOpen(false);
    navigate("/login"); // Redirect to login page
  };

  const handleCloseAccess = () => {
    toast.success("Redirecting to Login page", {
      autoClose: 2000,
      onClose: () => {
        navigate("/logout")
        // Cookies.remove("userToken");
      } // Redirect to login page
    })
  };

  const handleCloseModal = () => {
    setAccessModal(true)
  }

  return (
    <>

      <Modal open={accessModal} onClose={() => setAccessModal(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "white",
            p: 4,
            borderRadius: 2,
            boxShadow: 24,
            width: { xs: "90%", sm: 400 },
          }}
        >
          <Typography variant="h6" mb={5}>
            Are you sure you want to skip subscribing?
            <span style={{ fontSize: "12px", fontWeight: "600", color: "#757373d7" }}>Note: if YES, you'll be redirected to login page.</span>
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
            <Button onClick={() => setAccessModal(false)} variant="outlined">
              No
            </Button>
            <Button onClick={handleCloseAccess} variant="contained" color="primary">
              Yes
            </Button>
          </Box>
        </Box>
      </Modal>

      <Dialog open={open} onClose={handleLogin}>
        <DialogTitle>Session Expired</DialogTitle>
        <DialogContent>
          <Typography>
            Your session has expired. Please re-login to continue.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleLogin} color="primary" variant="contained">
            Login
          </Button>
        </DialogActions>
      </Dialog>
      {openBusinessModal && <BusinessFormModal onCloseModal={handleCloseModal} />}

      {/* {showIntroModal && <SequentialVideoModals />} */}
      {!isMobile && showIntroModal && <SequentialVideoModals />}
    </>
  );
};

export default AuthChecker;
